<template>
	<div>
		<layout-2 :id=pageid :navbar=true :title="'Add Trip'" :use_radio=true style="width:100%; height:calc(100vh - 50px);"></layout-2>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.ADD_TRIPS_PAGE
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/add/Add_Trips.vue